import { render, staticRenderFns } from "./FilterSection.vue?vue&type=template&id=608e45bd&scoped=true&"
import script from "./FilterSection.vue?vue&type=script&lang=js&"
export * from "./FilterSection.vue?vue&type=script&lang=js&"
import style0 from "./FilterSection.vue?vue&type=style&index=0&id=608e45bd&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "608e45bd",
  null
  
)

export default component.exports